import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../store/modules';

import { fetchHideNotification } from '../../store/modules/layout/actions';
import { fetchAvailableLogout } from '../../store/modules/login/actions';

import Header from '../../components/Header';
import Spinner from '../../components/Spinner';
import Notification from '../../components/Notification';
import InactivityWarningModal from '../../components/InactivityWarningModal';
import ModalLogoutInactivity from '../../components/ModalLogoutInactivity';

import mail from '../../assets/images/svg/ic-mail.svg';
import {
  LOCALSTORAGE_CONFIG,
  LOCALSTORAGE_LOGIN_TYPE,
} from '../../utils/constants/login';
import useIdleTimer from '../../hooks/useIdleTimer';
import { configServices } from '../../services/configServices';
import { LOG_MESSAGE_OBJECT } from '../../utils/constants/logConstants';
import { loggerServices } from '../../services/loggerServices';
import { clearStoredAuthSession, getStoredAccessToken } from '../../utils/authSession';

const MainLayout = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.layout.loading);
  const notification = useSelector(
    (state: RootState) => state.layout.notification
  );
  const token = getStoredAccessToken() || null;
  const history = useNavigate();

  const handleNotification = () => {
    dispatch(fetchHideNotification());
  };

  const handleLogout = React.useCallback(() => {
    const login = window.sessionStorage.getItem(LOCALSTORAGE_LOGIN_TYPE);
    dispatch(fetchAvailableLogout());
    clearStoredAuthSession();
    if (login === 'letter') history('/micuenta/ingresopin');
    else if (login === 'cash') history('/micuenta/ingresoseparacionci');
    else history('/micuenta/ingreso');
  }, [dispatch, history]);
  const [timeInactivity, setTimeInactivity] = useState(15 * 60 * 1000);

  const handleConfigServer = React.useCallback(() => {
    configServices
      .getConfigServer()
      .then((data) => {
        window.sessionStorage.setItem(
          LOCALSTORAGE_CONFIG,
          JSON.stringify(data.data)
        );
        setTimeInactivity(data.data.tiempoInactividad);
      })
      .catch((error) => {
        console.error('error al obtener configuración del servidor', error);
        const data = LOG_MESSAGE_OBJECT(
          'LetterPage->index.tsx->handleConfigServer',
          error,
          null
        );
        loggerServices
          .saveLog(data)
          .then(() => console.log('Se guardó log en servidor'))
          .catch((ex) => console.error('Se guardó log en servidor', ex));
      });
  }, []);

  useEffect(() => {
    handleConfigServer();
  }, [handleConfigServer]);

  //Inicio de lógica  de inactividad
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [counter, setCounter] = useState(59);
  const [expiredModalIdler, setExpiredModalIdler] = useState(false);

  const handlerTimeout = () => {
    if (!token) return;
    setShowWarningModal(true);
    setCounter(59);
  };

  useIdleTimer(timeInactivity, token, handlerTimeout);

  useEffect(() => {
    if (!token) {
      setShowWarningModal(false);
      setExpiredModalIdler(false);
      setCounter(59);
    }
  }, [token]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showWarningModal) {
      timer = setInterval(() => {
        setCounter((prev) => {
          if (prev > 0) {
            return prev - 1;
          } else {
            clearInterval(timer);
            setShowWarningModal(false);
            handleLogout();
            setExpiredModalIdler(true);
            return prev;
          }
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [handleLogout, showWarningModal]);

  const handlerContinueSession = () => {
    setShowWarningModal(false);
    setCounter(0);
  };

  const handlerLogout = () => {
    setShowWarningModal(false);
    setCounter(0);
    handleLogout();
  };

  const handleCloseModal = () => {
    setExpiredModalIdler(false);
  };

  return (
    <React.Fragment>
      <Spinner isShow={loading} />
      <Notification
        icon={mail}
        show={notification}
        onClose={handleNotification}
        text="Hemos enviado un correo con la confirmación de la desafiliación de tu tarjeta al débito automático"
      />
      <Header onClick={handleLogout} token={token} />
      {token && (
        <InactivityWarningModal
          isShow={showWarningModal}
          onContinue={handlerContinueSession}
          onLogout={handlerLogout}
          counter={counter}
        />
      )}
      {token && (
        <ModalLogoutInactivity
          isShow={expiredModalIdler}
          onClose={handleCloseModal}
        />
      )}
      <Outlet />
    </React.Fragment>
  );
};

export default MainLayout;
